/**
 * BOOTH Journal — category labels.
 *
 * Three content kinds, one optional audience suffix:
 *   Journal · Owners   Guide · Barbers   News
 *
 * Keeps index cards, article headers, and help guides aligned.
 */

export type JournalKind = "journal" | "guide" | "news"

export type JournalAudience = "owners" | "barbers" | "everyone"

const KIND_LABEL: Record<JournalKind, string> = {
  journal: "Article",
  guide: "Guide",
  news: "News",
}

const AUDIENCE_LABEL: Record<JournalAudience, string> = {
  owners: "Owners",
  barbers: "Barbers",
  everyone: "Everyone",
}

export function formatJournalCategory(kind: JournalKind, audience?: JournalAudience): string {
  if (!audience || audience === "everyone") return KIND_LABEL[kind]
  return `${KIND_LABEL[kind]} · ${AUDIENCE_LABEL[audience]}`
}

/** Help guides are always kind "guide". */
export function formatGuideCategory(audience: "owner" | "barber" | "everyone"): string {
  const map = { owner: "owners", barber: "barbers", everyone: "everyone" } as const satisfies Record<
    "owner" | "barber" | "everyone",
    JournalAudience
  >
  return formatJournalCategory("guide", map[audience])
}
